"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { isElementOverflowing } from "@/utils/Utils";
import { User } from "@/types/user";
import { Company, CompanyType } from "@/types/company";
import { useTranslation } from "@/app/i18n/client";
import { MdEmail, MdPhone, MdPhoneAndroid, MdPrint, MdPublic } from "react-icons/md";
import Obfuscate from "react-obfuscate";
import { OutboundLink } from "@/components/OutboundLink";
export function BusPartnerModalCard({
  company
}: {
  company: Company<Extract<CompanyType, "busoperator" | "touroperator">>;
  user?: User;
}) {
  const titleRef = useRef<HTMLDivElement>(null);
  return <div className="modal-card overflow-x-hidden">
      <div className="card-header">
        <div className="card-header-info-container">
          <div className="card-header-title-container">
            <div className="card-header-title">
              <div ref={titleRef} className={`${isElementOverflowing(titleRef.current) ? "marquee" : ""}`}>
                {company.publicData.companyName}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body-container flex flex-col gap-2 border-0">
        {company.publicData.description}
        <CompanyContact company={company} />
      </div>
    </div>;
}
function CompanyContact(t0) {
  const $ = _c(24);
  const {
    company
  } = t0;
  const {
    t
  } = useTranslation();
  const httpSuffix = company?.contactData.contact.website?.startsWith("http://", 0) || company?.contactData.contact.website?.startsWith("https://", 0) || false;
  const websitelink = httpSuffix ? `${company?.contactData.contact.website ?? ""}` : `https://${company?.contactData.contact.website ?? ""}`;
  let t1;
  if ($[0] !== t) {
    t1 = t("HOME.MODALS.CONTACT.TEXT");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="text-lg">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== company?.contactData.contact.telephone) {
    t3 = company?.contactData.contact.telephone && <div className="flex flex-row gap-2"><MdPhone /><Obfuscate tel={company?.contactData.contact.telephone}>{company?.contactData.contact.telephone}</Obfuscate></div>;
    $[4] = company?.contactData.contact.telephone;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== company?.contactData.contact.cellphone) {
    t4 = company?.contactData.contact.cellphone && <div className="flex flex-row gap-2"><MdPhoneAndroid /><Obfuscate tel={company?.contactData.contact.cellphone}>{company?.contactData.contact.cellphone}</Obfuscate></div>;
    $[6] = company?.contactData.contact.cellphone;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== company?.contactData.contact.fax) {
    t5 = company?.contactData.contact.fax && <div className="flex flex-row gap-2"><MdPrint /><Obfuscate tel={company?.contactData.contact.fax}>{company?.contactData.contact.fax}</Obfuscate></div>;
    $[8] = company?.contactData.contact.fax;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== company) {
    t6 = company?.contactData.contact.email && <div className="flex flex-row gap-2"><MdEmail /><Obfuscate email={company.contactData.contact.email}>{company.contactData.contact.email}</Obfuscate></div>;
    $[10] = company;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== company?.contactData.contact.website || $[13] !== websitelink) {
    t7 = company?.contactData.contact.website && <div className="flex flex-row gap-2"><MdPublic /><OutboundLink data-testid="company-website" eventLabel={`website:${company?.contactData.contact.website ?? ""}`} to={websitelink} target="_blank">{company?.contactData.contact.website}</OutboundLink></div>;
    $[12] = company?.contactData.contact.website;
    $[13] = websitelink;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className="">{t3}{t4}{t5}{t6}{t7}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t2}{t8}</div>;
    $[21] = t2;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}